import { useState } from "react";
import {
  ListSelector,
  ListSelectorItem,
  ListSelectorProps,
  useSnackbarsPipeline
} from "@bonliva-crm/ui";
import {
  ListUserSelectorUserFragment,
  useGetListUserSelectorUsersQuery
} from "@bonliva-crm/graphql";

type Props = {
  multi: boolean;
  value: string[];
  onSelect: (selected: ListUserSelectorUserFragment[]) => void;
  withSearch?: boolean;
  ListSelectorProps?: Partial<ListSelectorProps>;
};

export function ListUserSelector(props: Props) {
  const snack = useSnackbarsPipeline();

  const [items, setItems] = useState<ListSelectorItem[]>([]);

  const { loading, data } = useGetListUserSelectorUsersQuery({
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      const list: ListSelectorItem[] = [];

      for (const user of data.users) {
        if (user.Teams.length > 0) {
          for (const team of user.Teams) {
            list.push({
              group: team,
              label: user.Name,
              value: user._id
            });
          }
        } else {
          list.push({
            label: user.Name,
            value: user._id
          });
        }
      }

      setItems(list);
    },
    onError: (error) => {
      console.error(error);
      snack.showError("Error loading users");
    }
  });

  if (loading || !data) {
    return <div>Loading...</div>;
  }

  return (
    <ListSelector
      items={items}
      value={props.value}
      onChange={(ids) => {
        const items = data.users.filter((u) => ids.includes(u._id));
        props.onSelect(items);
      }}
      multi={props.multi}
      {...props.ListSelectorProps}
    />
  );
}
